console.debug(`VUE_APP_ISCACHE: ${process.env.VUE_APP_ISCACHE}`)
// const isCache = process.env.VUE_APP_ISCACHE === 'true' ? true : false
const BASEURL_DOMAIN = process.env.VUE_APP_APIURL_DATAPOSTER
const BASEURL_API = process.env.VUE_APP_APIURL_API

// 羽毛球 【汤尤杯】 接口 start ---------

function computedBaseUrl(baseApi) {
  // 不同开发环境，不同接口根目录，导致域名不同
  let baseUrl = ''
  if (
    process.env.NODE_ENV === 'development' &&
    process.env.VUE_APP_API === 'development'
  ) {
    // 本地开发
    return baseApi
  }
  if (baseApi.indexOf('/api') === 0) {
    baseUrl = BASEURL_API
  } else {
    baseUrl = BASEURL_DOMAIN
  }
  return baseUrl + baseApi
}

// 根据海报id获取海报内容
export const https_dataPoster_posterDetail = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(`${baseUrl}/poster/posterinfo/${params.posterId}`)
  )
}

// 根据分析项id和比赛id 获取海报主题实体对象
export const https_dataPoster_findAnalysisItemById = (
  baseUrl,
  axios,
  params
) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/analysis/poster/findAnalysisItemById`),
    params
  )
}

// 保存用户选择的 赛事和赛季
export const https_dataPoster_saveUseOpt = (baseUrl, axios, params) => {
  return axios.post(computedBaseUrl(`${baseUrl}/poster/saveuserselect`), params)
}

// 智能抠图 接口
export const https_dataPoster_cutoutImage = (baseUrl, axios, params) => {
  return axios.post(computedBaseUrl(`${baseUrl}/rmbg/submit`), params, {
    headers: {
      'content-type': 'application/json',
    },
  })
}

// 获取海报库列表
export const https_dataPoster_posterList = (baseUrl, axios, params) => {
  return axios.post(computedBaseUrl(`${baseUrl}/poster/posters`), params)
}

// 获取海报类型
export const https_dataPoster_posterTypes = (baseUrl, axios, params) => {
  return axios.get(computedBaseUrl(`${baseUrl}/poster/types`))
}
